import { useMutation, useQuery } from '@tanstack/react-query';
import { AttestationCode } from '../../../../constants';
import { getDentistAttestation, updateDentistAttestation } from '../../../../services/credentials';
import { showSuccessMessage } from '../../../../utils';

export const useDentistBenevisAttestationToggle = (officeId) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getDentistAttestation', `${officeId}-${AttestationCode.BENEVIS}`],
    queryFn: () => getDentistAttestation(officeId, AttestationCode.BENEVIS),
  });

  const isEnabled = !!data?.data?.data?.is_enabled;

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      updateDentistAttestation({
        officeId,
        code: AttestationCode.BENEVIS,
        isEnabled: !isEnabled,
      }),
    onMutate: () => {},
    onSuccess: async () => {
      await refetch();
      showSuccessMessage({ message: 'Benevis Attestation Updated' });
    },
  });

  return { isEnabled, isLoading: isLoading || isPending, onToggle: mutate };
};
